import styled from "styled-components";

interface IvisibilityState {
  visibilityMin?: boolean;
  visibilityMax?: boolean;
}
export const Container = styled.div<IvisibilityState>`
  color: #fff;
  width: 100%;
  display: grid;

  @media (min-width: 768px) {
    width: 70%;
  }  

  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    pointer-events: all;
    width: 24px;
    height: 24px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 0 0 1px #c6c6c6;
    cursor: pointer;
  }

  input[type="range"]::-moz-range-thumb {
    -webkit-appearance: none;
    pointer-events: all;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    box-shadow: 0 0 0 1px #c6c6c6;
    cursor: pointer;
  }

  input[type="range"]::-webkit-slider-thumb:hover {
    background: #f7f7f7;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    opacity: 1;
  }

  input[type="range"] {
    -webkit-appearance: none;
    appearance: none;
    height: 2px;
    width: 90%;
    margin: 12px 0;
    pointer-events: none;
  }
  .inputs{
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

`;
export const Content = styled.div`
  margin: 12px 0;
  display: flex;
  justify-content: space-between;
`;
